import AddEditLoansRow from "./AddEditLoansRow/AddEditLoansRow";
import { CustomDate } from "../../../../models/custom-date/custom-date";
import { TransactionToLoanAttributionRef } from "../../../../models/transaction-to-loan-attribution";
import { TransactionDTO } from "../../../../models/transactions";

import ConfirmationRemoveItemDialog from "../ConfirmationRemoveItemDialog/ConfirmationRemoveItemDialog";
import { Amounts, HeaderRow, MainBlock, StyledTableCell, TableBodyRow } from "../styles";

interface Props {
  transaction: TransactionDTO;
  readOnly?: boolean;
  handleChange?: (field: keyof TransactionDTO, value: TransactionDTO[keyof TransactionDTO]) => void;
}

const Loans = ({
  transaction: { loans, legalEntity, currency, transactionDate },
  readOnly = false,
  handleChange,
}: Props) => {
  const propsNotIds = loans.length !== 0 ? loans.map((item) => item?.loan?.id as string) : [];

  const handleChangeLoan = (value: TransactionToLoanAttributionRef, idx: number): void => {
    idx < 0
      ? handleChange && handleChange("loans", [...loans, value])
      : handleChange && handleChange("loans", [...loans.slice(0, idx), value, ...loans.slice(idx + 1)]);
  };

  const handleRemoveLoan = (idx: number): void =>
    handleChange && handleChange("loans", [...loans.slice(0, idx), ...loans.slice(idx + 1)]);

  return (
    <>
      <MainBlock>
        <HeaderRow container>
          <StyledTableCell
            flex={2}
            align={"left"}
          >
            Loans
          </StyledTableCell>
          <StyledTableCell
            flex={1}
            align={"right"}
          >
            Amount
          </StyledTableCell>
          <StyledTableCell flex={1}>Exchange rate</StyledTableCell>
          <StyledTableCell
            flex={1}
            align={"right"}
          >
            Booked amount
          </StyledTableCell>
          {!readOnly && (
            <StyledTableCell width={100}>
              <AddEditLoansRow
                handleChangeLoan={(value) => handleChangeLoan(value, -1)}
                legalEntity={legalEntity}
                propsNotIds={propsNotIds}
                currency={currency}
                date={CustomDate.ToDate(transactionDate) as Date}
              />
            </StyledTableCell>
          )}
        </HeaderRow>

        {loans?.map((loan, idx) => {
          return (
            <TableBodyRow
              container
              key={loan.id}
            >
              <StyledTableCell
                flex={2}
                align={"left"}
              >
                {loan?.loan?.legalEntity?.name} - {loan.loan?.borrowerLegalEntity?.name}
              </StyledTableCell>
              <StyledTableCell
                flex={1}
                align={"right"}
                title={`${(+loan?.amount).toLocaleCustom()} ${loan?.currency?.code ?? ""}`}
              >
                <Amounts>{`${(+loan?.amount).toLocaleCustom()} ${loan?.currency?.code ?? ""}`}</Amounts>
              </StyledTableCell>
              <StyledTableCell flex={1}>{loan?.exchangeRate}</StyledTableCell>
              <StyledTableCell
                flex={1}
                align={"right"}
                title={`${(+loan?.bookedAmount).toLocaleCustom()} ${loan?.bookedCurrency?.code ?? ""}`}
              >
                <Amounts>{`${(+loan?.bookedAmount).toLocaleCustom()} ${loan?.bookedCurrency?.code ?? ""}`}</Amounts>
              </StyledTableCell>
              {!readOnly && (
                <StyledTableCell width={100}>
                  <AddEditLoansRow
                    handleChangeLoan={(value) => handleChangeLoan(value, idx)}
                    legalEntity={legalEntity}
                    item={loan}
                    propsNotIds={propsNotIds}
                    date={CustomDate.ToDate(transactionDate) as Date}
                  />
                  <ConfirmationRemoveItemDialog
                    index={idx}
                    handleRemove={handleRemoveLoan}
                  />
                </StyledTableCell>
              )}
            </TableBodyRow>
          );
        })}
      </MainBlock>
    </>
  );
};

export default Loans;
